import App from './App.svelte';
import { authService } from "./services/auth.service";
const app = new App({
    target: document.body,
    props: {}
});
authService.handlePossibleLogin(); // fireAndForget...
export default app;
